import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { BsArrowLeft, BsBoxArrowRight, BsDisplay, BsLink45Deg, BsCheck2 } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import { useAuth } from '#globalContexts/AuthProvider';

const MobileBlockerScreen = () => {
	const { signOut } = useAuth();
	const navigate = useNavigate();
	const [copied, setCopied] = useState(false);

	const handleCopyLink = async () => {
		await navigator.clipboard.writeText(window.location.href);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	};

	return (
		<div className="flex items-center justify-center min-h-screen bg-gray-50 px-6">
			<div className="text-center max-w-sm">
				<div className="mx-auto mb-6 h-16 w-16 rounded-2xl bg-primary-100 text-primary-600 flex items-center justify-center">
					<BsDisplay className="w-8 h-8" />
				</div>
				<h1 className="text-lg font-bold text-text mb-2">Bitte wechseln Sie zum Desktop</h1>
				<p className="text-sm text-bgBase-800 leading-relaxed mb-8">
					Für Pipeline, Kampagnen und Analysen benötigen Sie einen größeren Bildschirm. Öffnen Sie B2B Hero an
					Ihrem Computer für das beste Erlebnis.
				</p>

				<div className="space-y-3">
					<Button fullWidth variant="solid" onClick={handleCopyLink}>
						{copied ? (
							<>
								<BsCheck2 className="w-4 h-4 mr-2" />
								Link kopiert!
							</>
						) : (
							<>
								<BsLink45Deg className="w-4 h-4 mr-2" />
								Link kopieren
							</>
						)}
					</Button>
					<Button fullWidth variant="outline" onClick={() => navigate('/dashboard')}>
						<BsArrowLeft className="w-4 h-4 mr-2" />
						Zurück zum Dashboard
					</Button>
					<Button fullWidth variant="outline" onClick={signOut}>
						<BsBoxArrowRight className="w-4 h-4 mr-2" />
						Abmelden
					</Button>
				</div>
			</div>
		</div>
	);
};

export default MobileBlockerScreen;
